import { getProjectDetail } from "api/project.api";
import ProjectSelect from "components/Select/Project";
import React from "react";
import { useDispatch } from "react-redux";
import { addName, replaceSearchBy } from "store/slices/searcSlice";


function parseInputToArray(input: any): string[] {
  try {
    // If the input is a JSON string, parse it
    if (typeof input === "string" && input.startsWith('["') && input.endsWith('"]')) {
      return JSON.parse(input);
    }

    // If the input is a comma-separated string, split it into an array
    if (typeof input === "string" && input.includes(',')) {
      return input.split(',').map(item => item.trim());
    }

    // If the input is a single string, wrap it in an array
    if (typeof input === "string") {
      return [input];
    }

    // If the input is already an array, return it
    if (Array.isArray(input)) {
      return input;
    }

    // If none of the above, return an empty array
    return [];
  } catch (error) {
    console.error("Error parsing input:", error);
    return [];
  }
}


const HandleProjectSelect = () => {
  const dispatch = useDispatch();
  const getProjectDetails = async (id: number) => {
    try {
      const project = await getProjectDetail(id);
      const parsedCompany = parseInputToArray(project.recruiting_company);
      const parsedCompanyDetails = parsedCompany.map((company: string) => ({
        name: company
      }));
      dispatch(addName(project.title));
      dispatch(replaceSearchBy({
        jobTitle: parseInputToArray(project.official_title),
        skills: project.skills,
        includeLocations: project.locations,
        includeCompanies: parsedCompanyDetails,
        keywords: project.keywords,
        minExp: project.min_experience ? project.min_experience : 0,
        maxExp: project.max_experience ? project.max_experience : 60
      }));

    } catch (error) {
      console.error("Error fetching project details:", error);
    }
  };

  return (
    <ProjectSelect onSelect={(selectedOption) => selectedOption && getProjectDetails(Number(selectedOption.id))} />
  );
};

export default HandleProjectSelect;
